const Utils = {
  namespaced: true,
  state: {
    plans: [
      {
        id: 1,
        name: 'Free',
        base_value: 0,
        users: 1,
        profiles: 50,
        storage: '10 Mb',
        main: false,
        free_mounths: 0,
        domain: false,
        email: false
      },
      {
        id: 2,
        name: 'Professional',
        base_value: 4.5,
        users: 1,
        profiles: 50,
        storage: '100 Mb',
        main: false,
        free_mounths: 1,
        domain: false,
        email: false
      },
      {
        id: 0,
        name: 'My System',
        base_value: 2.5,
        users: 1,
        profiles: 50,
        storage: '200 Mb',
        main: false,
        free_mounths: 1,
        domain: false,
        email: false
      }
    ],
    currencies: [
      {
        id: 1,
        name: 'Euro',
        symblo: '€',
        symbloLeft: false,
        factor: 1,
        code: 'euro'
      },
      {
        id: 2,
        name: 'Dolar',
        symblo: '$',
        symbloLeft: true,
        factor: 1,
        code: 'dolar'
      },
      {
        id: 3,
        name: 'Pound',
        symblo: '£',
        symbloLeft: false,
        factor: 1,
        code: 'pound'
      },
      {
        id: 4,
        name: 'Real',
        symblo: 'R$',
        symbloLeft: true,
        factor: 3,
        code: 'real'
      }
    ],
    languages: [
      // {
      //   id: 4,
      //   name: 'English US',
      //   native_name: 'English',
      //   flag: null,
      //   code: 'en-us',
      //   translate: 'english_us',
      //   default_currency_id: 2
      // },
      {
        id: 3,
        name: 'English',
        label: 'EN',
        native_name: 'English',
        flag: null,
        code: 'en',
        translate: 'english',
        default_currency_id: 3,
        img: "en.svg"
      },
      {
        id: 1,
        name: 'Portuguese',
        label: 'PT',
        native_name: 'Português',
        flag: null,
        code: 'pt',
        translate: 'portuguese',
        default_currency_id: 1,
        img: "pt.svg"
      },
      {
        id: 2,
        name: 'Portuguese - BR',
        label: 'PT-BR',
        native_name: 'Português - BR',
        flag: null,
        code: 'pt_br',
        translate: 'portuguese_br',
        default_currency_id: 4,
        img: "pt-br.svg"
      }
      // {
      //   id: 5,
      //   name: 'Spanish',
      //   native_name: 'Espanhol',
      //   flag: null,
      //   code: 'es',
      //   translate: 'spanish',
      //   default_currency_id: 1
      // }
    ],
    countries: [],
    selectedLanguageId: 3,
    selectedPlanId: 1,
    selectedCurrencyId: 2,
    showTermsUse: false,
    showPrivacyPolicy: false
  },
  getters: {
    selectedCurrency(state) {
      return state.currencies.find((currency) => {
        return currency.id === state.selectedCurrencyId;
      });
    },
    selectedPlan(state) {
      return state.plans.find((plan) => {
        return plan.id === state.selectedPlanId;
      });
    },
    selectedLanguage(state) {
      return state.languages.find((lang) => {
        return lang.id === state.selectedLanguageId;
      });
    },
    urlLogin(state, getters) {
      let url = 'http://system.processflex.com';
      return `${url}?lang=${getters.selectedLanguage.code}`; 
    }
  },
  mutations: {
    setSelectedLanguageId(state, id) {
      state.selectedLanguageId = id;
    },
    setPlans(state, plans) {
      state.plans = plans;
    },
    setCurrencies(state, currencies) {
      state.currencies = currencies;
    },
    setSelectedCurrencies(state, id) {
      state.selectedCurrencyId = id;
    },
    setSelectedPlan(state, id) {
      state.selectedPlanId = id;
    },
    setShowTermsUse(state, value) {
      state.showTermsUse = value;
    },
    setShowPrivacyPolicy(state, value) {
      state.showPrivacyPolicy = value;
    },
    setCountries(state, countries) {
      state.countries = countries;
    }
  },
  actions: {
    setSelectedLanguageId({commit}, id) {
      commit('setSelectedLanguageId', id);
    },
    getPlans({ state }) {
      return new Promise((resolve) => {
        resolve(state.plans);
      });
    },
    getCurrencies({ state }) {
      return new Promise((resolve) => {
        resolve(state.currencies);
        // axios
        // .post("api/system/file", data)
        // .then(response => {
        //   resolve(response);
        // })
        // .catch(errors => {
        //   console.log("Error...");
        //   reject(errors);
        // });
      });
    },
    setSelectPlan({ commit }, id) {
      commit('setSelectedPlan', id);
    },
    setSelectedCurrency({ commit }, id) {
      commit('setSelectedCurrencies', id);
    },
    getCountries({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (!state.countries.length) {
          window.axios.get('api/country')
            .then(response => {
              commit('setCountries', response.data);
              resolve(response.data);
            })
            .catch((error) => {
              this.isLoading = false;
              reject(error.data);
            });
        }
      });

    }
  }
};

export default Utils;
